import React from 'react';
import { motion } from 'framer-motion';
import { Users, Target, Award, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './About.css';

const About = () => {
  const navigate = useNavigate();

  const values = [
    {
      icon: <Users size={32} />,
      title: 'Expert Team',
      description: 'Our team of skilled professionals brings years of experience in cutting-edge technologies.'
    },
    {
      icon: <Target size={32} />,
      title: 'Client-Focused',
      description: 'We prioritize our clients\' needs and deliver customized solutions that drive business growth.'
    },
    {
      icon: <Award size={32} />,
      title: 'Quality Assurance',
      description: 'We maintain the highest standards of quality in every project we undertake.'
    },
    {
      icon: <Globe size={32} />,
      title: 'Global Reach',
      description: 'Serving clients worldwide with our comprehensive software solutions and IT services.'
    }
  ];

  return (
    <section id="about" className="about section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">About Noonic Solutions</h2>
          <p className="section-subtitle">
            Transforming businesses through innovative technology solutions and expert IT manpower
          </p>
        </motion.div>

        <div className="about-content">
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h3>Our Mission</h3>
            <p>
              At Noonic Solutions, we are dedicated to empowering businesses with cutting-edge software solutions 
              and top-tier IT talent. Our mission is to bridge the gap between technological innovation and 
              business success by providing specialized expertise in Fintech, ERP systems, Supply Chain Management, 
              Software Development Life Cycle, Cloud computing, and Artificial Intelligence.
            </p>
            
            <h3>Why Choose Us?</h3>
            <p>
              With over a decade of experience in the software industry, we understand the challenges businesses 
              face in today's digital landscape. Our comprehensive approach combines strategic thinking, 
              technical excellence, and industry best practices to deliver solutions that not only meet your 
              immediate needs but also position your business for future growth.
            </p>
            
            <div className="about-highlights">
              <div className="highlight">
                <span className="highlight-number">5+</span>
                <span className="highlight-text">Years of Experience</span>
              </div>
              <div className="highlight">
                <span className="highlight-number">6</span>
                <span className="highlight-text">Core Specializations</span>
              </div>
              <div className="highlight">
                <span className="highlight-number">10+</span>
                <span className="highlight-text">Satisfied Clients</span>
              </div>
            </div>
          </motion.div>

          <motion.div 
            className="about-values"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
          >
            <h3>Our Values</h3>
            <div className="values-grid">
              {values.map((value, index) => (
                <motion.div 
                  key={index}
                  className="value-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 * index }}
                  viewport={{ once: true }}
                >
                  <div className="value-icon">{value.icon}</div>
                  <h4>{value.title}</h4>
                  <p>{value.description}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        
      </div>
    </section>
  );
};

export default About;
